module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"options":"Options","open-original":"Open original","attach-image":"Attach image"},"pt-BR":{"options":"Opções","open-original":"Abrir original","attach-image":"Anexar imagem"}}')
  delete Component.options._Ctor
}
